import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Material UI
import {Grid} from "@mui/material";

// Components
import CustomButton from "components/CustomButton";
import UnavailabilityDrawer from "./UnavailabilityDrawer";

// API
import {wmsItemInTrolley} from "api/wms/wmsItems/wmsItems";

// Contexts
import {MissionContext} from "views/wms/task/context/MissionContext";
import {WMSContext} from "views/wms/context/WMSContext";

PickingActions.propTypes = {
    selectedWmsItem: PropTypes.object,
    handleCloseDrawer: PropTypes.func.isRequired,
};

function PickingActions({selectedWmsItem, handleCloseDrawer}) {
    const [openUnavailabilityDrawer, setOpenUnavailabilityDrawer] = useState(false);
    const [loading, setLoading] = useState(false);

    const {refreshMission, currentContainer} = React.useContext(MissionContext);
    const {currentTask} = React.useContext(WMSContext);

    if (!currentContainer || !currentTask) {
        return null;
    }

    async function putWmsItemInTrolley(wmsItem) {
        if (!wmsItem || !currentContainer.codebar) {
            return;
        }

        setLoading(true)

        const res = await wmsItemInTrolley(wmsItem, currentContainer.codebar);

        setLoading(false);

        if (res) {
            handleCloseDrawer();
            refreshMission();
        }
    }

    return (
        <Grid
            container
            spacing={2}
            direction={'column'}
        >
            <Grid item>
                <CustomButton
                    color={'blue'}
                    fullWidth={true}
                    thicker={true}
                    disabled={loading}
                    onClick={() => putWmsItemInTrolley(selectedWmsItem)}
                >
                    <FormattedMessage id='wms.myPickingMissions.popup.product.action.confirm' />
                </CustomButton>
            </Grid>
            <Grid item>
                <CustomButton
                    color={'red'}
                    variant={'nude'}
                    fullWidth={true}
                    thicker={true}
                    onClick={() => setOpenUnavailabilityDrawer(true)}
                >
                    <FormattedMessage id='wms.myPickingMissions.popup.product.action.cancel' />
                </CustomButton>
            </Grid>
            <UnavailabilityDrawer
                wmsItem={selectedWmsItem}
                open={openUnavailabilityDrawer}
                handleClose={() => {
                    setOpenUnavailabilityDrawer(false)
                    handleCloseDrawer();
                    refreshMission();
                }}
            />
        </Grid>
    );
}

export default PickingActions;
